module.exports = __webpack_public_path__ + "img/5458.31a7668a.jpg";